import axios from 'axios'
import type {
    CebiGlassInfoDto,
    GetCebiGlassRequest,
    GetMakersRequest,
    GetModelsBaseRequest,
    GetModelsRequest,
    VehiclesIdentificationDto,
    VehicleValuationDto,
    VinOnlineVehicleDto,
} from 'BrokerTsLib/src/dtos'
import type { GenericQueryOptions, VehicleValuationModel } from 'brokertslib/src/hooks'
import { longStaleTime } from 'brokertslib/src/hooks'
import { useMutation, useQuery } from 'react-query'
import { baseUrl } from '.'

const apiUrl = import.meta.env.VITE_VINONLINE_API
const url = `${baseUrl}/${apiUrl}`

const findVehicle = (data: VehicleIdentificationPropsDto) =>
  axios.post<VinOnlineVehicleDto>(`${url}/FindVehicle`, data)
export const useFindVehicle = () => {
  return useMutation(findVehicle)
}
const vehicleIdentification = (data: VehicleIdentificationPropsDto) =>
  axios.post<VehiclesIdentificationDto>(`${url}/VehicleIdentification`, data)
export const useVehicleIdentification = () => {
  return useMutation(vehicleIdentification)
}

const vehicleValuation = (data: VehicleValuationModel) =>
  axios.post<VehicleValuationDto>(`${url}/VehicleValuation`, data)
export const useVehicleValuation = () => {
  return useMutation(vehicleValuation)
}

const cebiGlass = (data: GetCebiGlassRequest) =>
  axios.post<CebiGlassInfoDto>(`${url}/CebiGlass`, data)
export const useCebiGlass = () => useMutation(cebiGlass)

export type VehicleIdentificationPropsDto = {
  paramsId?: string
  spz?: string | null
  vin?: string | null
  techCertNumber?: string | null
}

const fetchMakers = (request: GetMakersRequest) => axios.post<string[]>(`${url}/GetMakers`, request)

const fetchAllMakers = () => axios.post<string[]>(`${url}/GetAllMakers`)

const fetchModelsBase = (request: GetModelsBaseRequest) =>
  axios.post<string[]>(`${url}/GetModelsBase`, request)

const fetchModels = (request: GetModelsRequest) => axios.post<string[]>(`${url}/GetModels`, request)

export const useGetMakers = (
  request: GetMakersRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery(
    ['vinOnline-useGetVehicleMakers', request.categoryId, request.fuelId],
    () => fetchMakers(request),
    { staleTime: longStaleTime, ...options },
  )
}

export const useGetAllMakers = (
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery(
    ['vinOnline-useGetAllVehicleMakers'],
    () => fetchAllMakers(),
    { staleTime: longStaleTime, ...options },
  )
}

export const useGetModelsBase = (
  request: GetModelsBaseRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery(
    ['vinOnline-useGetModelsBase', request.categoryId, request.fuelId, request.maker],
    () => fetchModelsBase(request),
    { staleTime: longStaleTime, ...options },
  )
}

export const useGetModels = (
  request: GetModelsRequest,
  options?: GenericQueryOptions<string[]>,
) => {
  return useQuery(
    [
      'vinOnline-useGetModels',
      request.categoryId,
      request.fuelId,
      request.maker,
      request.modelBase,
    ],
    () => fetchModels(request),
    { staleTime: longStaleTime, ...options },
  )
}
